import { combineReducers } from 'redux';
import signIn from './performLogin';
import addNewUser from './addNewUser';

export default combineReducers({
  signIn,
  addNewUser,
});
